import {HTMLAttributes} from 'react';
import {StoreErrorChecker} from '../../common/checkers/StoreErrorChecker';
import {twMerge} from '../../common/twMerge';
import {ApiErrorBoundary} from '../../errors/ApiErrorBoundary.class';
import {PcBackHeader} from '../organisms/PcBackHeader/PcBackHeader';
import {FooterType} from './LayoutFooter/FooterType.enum';
import {LayoutFooter} from './LayoutFooter/LayoutFooter';
import {PcHeaderType} from './PcHeaderType.enum';
import {PcLayoutConfig} from './PcLayoutConfig.interface';
import {PcLayoutHeader} from './PcLayoutHeader';
import {PcLayoutViewerCommentHeader} from './PcLayoutViewerCommentHeader';
import {PcLayoutViewerHeader} from './PcLayoutViewerHeader';

interface Props extends PcLayoutConfig, HTMLAttributes<HTMLDivElement> {}

/**
 * XXX: PC 헤더의 경우 백버튼이나 로고, 숏컷 메뉴와 관련된 기획이 결정된게 없어서, 해당 요소들의 대한 제어를 추가하지 않았습니다.
 * 추후 기획이 결정되면 추가되어야 합니다.
 */
export function PcLayout({
  children,
  shouldShowFooter,
  shouldShowHeader,
  headerType = PcHeaderType.Common,
  footerType = FooterType.Common,
  shouldUseFixedWidth = true,
  className,
  isLayoutV2,
  ...props
}: Props) {
  return (
    <div
      className={twMerge(
        'relative flex w-full grow flex-col items-center',
        shouldUseFixedWidth && 'mx-auto w-1200pxr',
        isLayoutV2 && 'bg-theme-bg-base-alt',
        className
      )}
      {...props}
    >
      {shouldShowHeader && headerType === PcHeaderType.Common && (
        <PcLayoutHeader />
      )}
      {shouldShowHeader && headerType === PcHeaderType.Viewer && (
        <div className="fixed top-0 z-150 flex w-full justify-center bg-theme-bg-base">
          <PcLayoutViewerHeader />
        </div>
      )}
      {isLayoutV2 && headerType === PcHeaderType.Back && <PcBackHeader />}
      {shouldShowHeader && headerType === PcHeaderType.ViewerComment && (
        <PcLayoutViewerCommentHeader />
      )}
      <ApiErrorBoundary refreshOnRetry={true}>
        <StoreErrorChecker>
          <div
            className={twMerge(
              'flex w-full grow flex-col',
              shouldUseFixedWidth && 'px-122pxr',
              isLayoutV2 && 'w-956pxr'
            )}
          >
            {children}
          </div>
        </StoreErrorChecker>
      </ApiErrorBoundary>
      {shouldShowFooter && <LayoutFooter footerType={footerType} />}
    </div>
  );
}
